import { render, staticRenderFns } from "./TranUserPackageActivityReminderListFilter.vue?vue&type=template&id=0178c8d4&scoped=true"
import script from "./TranUserPackageActivityReminderListFilter.vue?vue&type=script&lang=js"
export * from "./TranUserPackageActivityReminderListFilter.vue?vue&type=script&lang=js"
import style0 from "./TranUserPackageActivityReminderListFilter.vue?vue&type=style&index=0&id=0178c8d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0178c8d4",
  null
  
)

export default component.exports